import { TranslateService } from '@ngx-translate/core';
import { Meta } from '@angular/platform-browser';
import { forkJoin } from 'rxjs';

interface TagInfo {
  property: string;
  translationKey: string;
}

export function updateMetaTags(translateService: TranslateService, meta: Meta, tagInfos: TagInfo[]) {
  const observables = tagInfos.map(tagInfo => translateService.get(tagInfo.translationKey));

  forkJoin(observables).subscribe(translations => {
    translations.forEach((translatedContent, index) => {
      meta.updateTag({ property: tagInfos[index].property, content: translatedContent });
    });
  });
}
